const PAYLOAD_WRAP_CONTEXT = 'oma-data-payload-v2';

function base64ToBytes(value) {
    const binary = atob(value);
    return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

export async function unwrapPayload(raw, token, ts) {
    if (!raw || !raw._s) return raw;
    if (raw._v !== 2) throw new Error(`unsupported payload version: ${raw._v}`);
    if (!token || !ts) throw new Error('missing payload unwrap material');

    const keyMaterial = `${token}:${ts}:${PAYLOAD_WRAP_CONTEXT}`;
    const keyBuffer = await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(keyMaterial),
    );
    const key = new Uint8Array(keyBuffer);
    const reversed = raw._d.split('').reverse().join('');
    const xored = base64ToBytes(reversed);
    const output = xored.map((byte, index) => byte ^ key[index % key.length]);
    return JSON.parse(new TextDecoder('utf-8').decode(output));
}
